/**
 * Main App class.
 */
export class ScrollSpy{
  /**
  * Constructor
  */
  constructor() {
    this.init = this.init.bind(this);
  }

  isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

  };

  init() {
    window.addEventListener('scroll', (e) => {
      if(this.isInViewport(document.querySelector('.nav-main'))) {
        document.querySelector('.backtop').classList.add('hidden');
        return;
      };
      return document.querySelector('.backtop').classList.remove('hidden');
    });
    document.querySelector('.backtop').classList.add('hidden');
  }
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
